module.exports = __webpack_public_path__ + "img/grend_5.8808a21e.jpg";